export default __webpack_public_path__ + "media/images/icon_reply-0aa2495d5aaf794fd77cc0dc222eac72.svg";